export default __webpack_public_path__ + "static/media/mountains-home.e567e0a9.png";